import { CSV_BILL_NAME } from '@/const/router';
import i18n from '@/i18n/locale';

export default [
  // 发单页
  {
    path: '/bill',
    name: 'Bill',
    meta: {
      title: '快速发单',
      sideMenu: {
        weight: 100,
        label: i18n.t('Entrega_order__zXtO'),
        icon: 'icon-filled_other',
        type: 1,
      },
      footer: {
        visible: false,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "entregaBill" */
        '@/views/Bill.vue'
      ),
  },
  {
    path: '/csv-bill',
    name: CSV_BILL_NAME,
    meta: {
      title: '导入发单',
      sideMenu: {
        weight: 80,
        label: i18n.t('Entrega_order__ixiy'),
        icon: 'icon-filled_threshold',
        type: 2,
      },
      footer: {
        visible: false,
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "entregaCsvBill" */
        '@/views/CsvBill.vue'
      ),
  },
];
